'use strict';

var cov_1dxtg8f212 = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/cart/lib/actions.js',
      hash = '1ce3e7ac02ee25122bc53788552463f8d520daf6',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/cart/lib/actions.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 28
        },
        end: {
          line: 6,
          column: 2
        }
      },
      '1': {
        start: {
          line: 4,
          column: 35
        },
        end: {
          line: 6,
          column: 1
        }
      },
      '2': {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 11,
          column: 2
        }
      },
      '3': {
        start: {
          line: 8,
          column: 38
        },
        end: {
          line: 11,
          column: 1
        }
      },
      '4': {
        start: {
          line: 13,
          column: 27
        },
        end: {
          line: 15,
          column: 2
        }
      },
      '5': {
        start: {
          line: 13,
          column: 34
        },
        end: {
          line: 15,
          column: 1
        }
      },
      '6': {
        start: {
          line: 17,
          column: 29
        },
        end: {
          line: 19,
          column: 2
        }
      },
      '7': {
        start: {
          line: 17,
          column: 36
        },
        end: {
          line: 19,
          column: 1
        }
      },
      '8': {
        start: {
          line: 23,
          column: 13
        },
        end: {
          line: 49,
          column: 1
        }
      },
      '9': {
        start: {
          line: 23,
          column: 25
        },
        end: {
          line: 49,
          column: 1
        }
      },
      '10': {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 34
        }
      },
      '11': {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 30,
          column: 3
        }
      },
      '12': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 48
        }
      },
      '13': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 23
        }
      },
      '14': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 48,
          column: 7
        }
      },
      '15': {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 41,
          column: 7
        }
      },
      '16': {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 38,
          column: 56
        }
      },
      '17': {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 45
        }
      },
      '18': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 20
        }
      },
      '19': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 21
        }
      },
      '20': {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 37
        }
      },
      '21': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 102
        }
      },
      '22': {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 22
        }
      },
      '23': {
        start: {
          line: 58,
          column: 17
        },
        end: {
          line: 85,
          column: 1
        }
      },
      '24': {
        start: {
          line: 58,
          column: 38
        },
        end: {
          line: 85,
          column: 1
        }
      },
      '25': {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 34
        }
      },
      '26': {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 84,
          column: 7
        }
      },
      '27': {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 75,
          column: 7
        }
      },
      '28': {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 56
        }
      },
      '29': {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 45
        }
      },
      '30': {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 32
        }
      },
      '31': {
        start: {
          line: 76,
          column: 20
        },
        end: {
          line: 76,
          column: 76
        }
      },
      '32': {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 51
        }
      },
      '33': {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 18
        }
      },
      '34': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 37
        }
      },
      '35': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 102
        }
      },
      '36': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 22
        }
      },
      '37': {
        start: {
          line: 87,
          column: 28
        },
        end: {
          line: 89,
          column: 1
        }
      },
      '38': {
        start: {
          line: 87,
          column: 34
        },
        end: {
          line: 89,
          column: 1
        }
      },
      '39': {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 35
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 28
          },
          end: {
            line: 4,
            column: 29
          }
        },
        loc: {
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 30
          }
        },
        loc: {
          start: {
            line: 8,
            column: 38
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 8
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 13,
            column: 28
          }
        },
        loc: {
          start: {
            line: 13,
            column: 34
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 13
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 17,
            column: 29
          },
          end: {
            line: 17,
            column: 30
          }
        },
        loc: {
          start: {
            line: 17,
            column: 36
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 17
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 23,
            column: 13
          },
          end: {
            line: 23,
            column: 14
          }
        },
        loc: {
          start: {
            line: 23,
            column: 25
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 23
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 23,
            column: 25
          },
          end: {
            line: 23,
            column: 26
          }
        },
        loc: {
          start: {
            line: 23,
            column: 37
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 23
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 36,
            column: 11
          }
        },
        loc: {
          start: {
            line: 36,
            column: 22
          },
          end: {
            line: 43,
            column: 5
          }
        },
        line: 36
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 44,
            column: 12
          }
        },
        loc: {
          start: {
            line: 44,
            column: 23
          },
          end: {
            line: 48,
            column: 5
          }
        },
        line: 44
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 58,
            column: 17
          },
          end: {
            line: 58,
            column: 18
          }
        },
        loc: {
          start: {
            line: 58,
            column: 38
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 58
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 58,
            column: 38
          },
          end: {
            line: 58,
            column: 39
          }
        },
        loc: {
          start: {
            line: 58,
            column: 50
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 58
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 70,
            column: 11
          }
        },
        loc: {
          start: {
            line: 70,
            column: 22
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 70
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 80,
            column: 11
          },
          end: {
            line: 80,
            column: 12
          }
        },
        loc: {
          start: {
            line: 80,
            column: 23
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 80
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 87,
            column: 28
          },
          end: {
            line: 87,
            column: 29
          }
        },
        loc: {
          start: {
            line: 87,
            column: 34
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 87
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 87,
            column: 34
          },
          end: {
            line: 87,
            column: 35
          }
        },
        loc: {
          start: {
            line: 87,
            column: 46
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 87
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }, {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }],
        line: 27
      },
      '1': {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 37
      },
      '2': {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 32
          }
        }, {
          start: {
            line: 37,
            column: 36
          },
          end: {
            line: 37,
            column: 57
          }
        }],
        line: 37
      },
      '3': {
        loc: {
          start: {
            line: 38,
            column: 21
          },
          end: {
            line: 38,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 38,
            column: 21
          },
          end: {
            line: 38,
            column: 34
          }
        }, {
          start: {
            line: 38,
            column: 38
          },
          end: {
            line: 38,
            column: 56
          }
        }],
        line: 38
      },
      '4': {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        }],
        line: 71
      },
      '5': {
        loc: {
          start: {
            line: 71,
            column: 10
          },
          end: {
            line: 71,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 71,
            column: 10
          },
          end: {
            line: 71,
            column: 32
          }
        }, {
          start: {
            line: 71,
            column: 36
          },
          end: {
            line: 71,
            column: 57
          }
        }],
        line: 71
      },
      '6': {
        loc: {
          start: {
            line: 72,
            column: 21
          },
          end: {
            line: 72,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 72,
            column: 21
          },
          end: {
            line: 72,
            column: 34
          }
        }, {
          start: {
            line: 72,
            column: 38
          },
          end: {
            line: 72,
            column: 56
          }
        }],
        line: 72
      },
      '7': {
        loc: {
          start: {
            line: 74,
            column: 15
          },
          end: {
            line: 74,
            column: 31
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 74,
            column: 15
          },
          end: {
            line: 74,
            column: 19
          }
        }, {
          start: {
            line: 74,
            column: 23
          },
          end: {
            line: 74,
            column: 31
          }
        }],
        line: 74
      },
      '8': {
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 38
          }
        }, {
          start: {
            line: 77,
            column: 42
          },
          end: {
            line: 77,
            column: 50
          }
        }],
        line: 77
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gAxios = require('@gravity/g-axios');

var _gAxios2 = _interopRequireDefault(_gAxios);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cov_1dxtg8f212.s[0]++;


var getBeforeLoadAction = function getBeforeLoadAction() {
  cov_1dxtg8f212.f[0]++;
  cov_1dxtg8f212.s[1]++;
  return {
    type: _constants2.default.CART_BEFORE_LOAD
  };
};

cov_1dxtg8f212.s[2]++;
var getLoadSuccessAction = function getLoadSuccessAction(data) {
  cov_1dxtg8f212.f[1]++;
  cov_1dxtg8f212.s[3]++;
  return {
    type: _constants2.default.CART_LOAD_SUCCESS,
    data: data
  };
};

cov_1dxtg8f212.s[4]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_1dxtg8f212.f[2]++;
  cov_1dxtg8f212.s[5]++;
  return {
    type: _constants2.default.CART_LOAD_ERROR
  };
};

cov_1dxtg8f212.s[6]++;
var getInitialCartAction = function getInitialCartAction() {
  cov_1dxtg8f212.f[3]++;
  cov_1dxtg8f212.s[7]++;
  return {
    type: _constants2.default.CART_INITIAL_STATE
  };
};
/*
 * The loader get the cart object
 */
cov_1dxtg8f212.s[8]++;
var load = function load(config) {
  cov_1dxtg8f212.f[4]++;
  cov_1dxtg8f212.s[9]++;
  return function (dispatch) {
    cov_1dxtg8f212.f[5]++;
    cov_1dxtg8f212.s[10]++;

    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    // if the configuration contains already the cart, set data directly
    cov_1dxtg8f212.s[11]++;
    if (config.cart) {
      cov_1dxtg8f212.b[0][0]++;
      cov_1dxtg8f212.s[12]++;

      dispatch(getLoadSuccessAction(config.cart));
      cov_1dxtg8f212.s[13]++;
      return config.cart;
    } else {
      cov_1dxtg8f212.b[0][1]++;
    }
    // then fetch the section
    cov_1dxtg8f212.s[14]++;
    return (0, _gAxios2.default)(config.restHost + '/v1/cart', {
      headers: config.headers,
      withCredentials: true
    }).then(function (response) {
      cov_1dxtg8f212.f[6]++;
      cov_1dxtg8f212.s[15]++;

      if ((cov_1dxtg8f212.b[2][0]++, response.status >= 200) && (cov_1dxtg8f212.b[2][1]++, response.status < 300)) {
        cov_1dxtg8f212.b[1][0]++;

        var cart = (cov_1dxtg8f212.s[16]++, (cov_1dxtg8f212.b[3][0]++, response.data) && (cov_1dxtg8f212.b[3][1]++, response.data.cart));
        cov_1dxtg8f212.s[17]++;
        dispatch(getLoadSuccessAction(cart));
        cov_1dxtg8f212.s[18]++;
        return cart;
      } else {
        cov_1dxtg8f212.b[1][1]++;
      }
      cov_1dxtg8f212.s[19]++;
      throw response;
    }).catch(function (response) {
      cov_1dxtg8f212.f[7]++;
      cov_1dxtg8f212.s[20]++;

      dispatch(getLoadErrorAction());
      cov_1dxtg8f212.s[21]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_1dxtg8f212.s[22]++;
      return response;
    });
  };
};

/*
 * Add items to the cart. options contains the following data :
 * (ProductType) product :  the product that it sold. If it is an event or visit, the timeslot or performance should be passed through
 *                          the performances or timeslots value
 *                          It must contain the tariff values
 * (Map Number, Number) tariffQuantity: the tariffQuantity is a map of tariffId -> the quantity taken
 */
cov_1dxtg8f212.s[23]++;
var addItems = function addItems(config, options) {
  cov_1dxtg8f212.f[8]++;
  cov_1dxtg8f212.s[24]++;
  return function (dispatch) {
    cov_1dxtg8f212.f[9]++;
    cov_1dxtg8f212.s[25]++;

    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());

    cov_1dxtg8f212.s[26]++;
    return (0, _gAxios2.default)(config.restHost + '/v1/cart', {
      headers: config.headers,
      withCredentials: true,
      method: 'POST',
      data: {
        items: options.items
      }
    }).then(function (response) {
      cov_1dxtg8f212.f[10]++;
      cov_1dxtg8f212.s[27]++;

      if ((cov_1dxtg8f212.b[5][0]++, response.status >= 200) && (cov_1dxtg8f212.b[5][1]++, response.status < 300)) {
        cov_1dxtg8f212.b[4][0]++;

        var cart = (cov_1dxtg8f212.s[28]++, (cov_1dxtg8f212.b[6][0]++, response.data) && (cov_1dxtg8f212.b[6][1]++, response.data.cart));
        cov_1dxtg8f212.s[29]++;
        dispatch(getLoadSuccessAction(cart));
        cov_1dxtg8f212.s[30]++;
        return (cov_1dxtg8f212.b[7][0]++, cart) || (cov_1dxtg8f212.b[7][1]++, response);
      } else {
        cov_1dxtg8f212.b[4][1]++;
      }
      var error = (cov_1dxtg8f212.s[31]++, new Error(response.status + ' (' + response.statusText + ')'));
      cov_1dxtg8f212.s[32]++;
      error.response = (cov_1dxtg8f212.b[8][0]++, response.json()) || (cov_1dxtg8f212.b[8][1]++, response);
      cov_1dxtg8f212.s[33]++;
      throw error;
    }).catch(function (response) {
      cov_1dxtg8f212.f[11]++;
      cov_1dxtg8f212.s[34]++;

      dispatch(getLoadErrorAction());
      cov_1dxtg8f212.s[35]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_1dxtg8f212.s[36]++;
      return response;
    });
  };
};

cov_1dxtg8f212.s[37]++;
var initializeCartState = function initializeCartState() {
  cov_1dxtg8f212.f[12]++;
  cov_1dxtg8f212.s[38]++;
  return function (dispatch) {
    cov_1dxtg8f212.f[13]++;
    cov_1dxtg8f212.s[39]++;

    dispatch(getInitialCartAction());
  };
};

exports.default = { load: load, addItems: addItems, initializeCartState: initializeCartState };